// API Configuration
const API_CONFIG = {
  // Development environment - use relative path for Nginx proxy
  development: {
    baseURL: '/api'
  },
  // Production environment - use relative path for Nginx proxy
  production: {
    baseURL: '/api'
  }
}

// Get current environment
const isProduction = import.meta.env.PROD
const currentEnv = isProduction ? 'production' : 'development'

export const API_BASE_URL = API_CONFIG[currentEnv].baseURL

// Debug logging
console.log('Environment:', currentEnv)
console.log('API_BASE_URL:', API_BASE_URL)
console.log('VITE_API_URL:', import.meta.env.VITE_API_URL)

// API endpoints
export const API_ENDPOINTS = {
  // Projects
  PROJECTS: '/admin/projects',
  PROJECT: (id) => `/admin/projects/${id}`,

  // Categories
  CATEGORIES: '/public/categories',

  // Products
  PRODUCTS: '/admin/products',
  PRODUCT: (id) => `/admin/products/${id}`,

  // Inquiries
  INQUIRIES: '/inquiries',
  INQUIRY: (id) => `/inquiries/${id}`,
  INQUIRY_STATS: '/admin/inquiries/stats/summary',

  // Contents
  CONTENTS: '/admin/contents',

  // Upload
  UPLOAD: '/upload',

  // Auth
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  CHECK_SESSION: '/auth/check'
}

// Helper function to build full URL
export const buildApiUrl = (endpoint) => {
  return `${API_BASE_URL}${endpoint}`
}

export default {
  API_BASE_URL,
  API_ENDPOINTS,
  buildApiUrl
}